// extracted by mini-css-extract-plugin
module.exports = {"lobby":"lobby_lobby__1mDdc","title":"lobby_title__1BOv_","animation":"lobby_animation__2MMkZ"};